import React from "react";
import { Link } from "react-router-dom";
import { addEndingSlashToSlug, getColourClass, getColours, getColourIndex } from "../../utils/general";


class MenuItem extends React.Component {

    render() {
        const menuItem = this.props.data;

        if (!menuItem) {
            return false;
        }

        const removeDisplayBlockClass = (e) => {

            const displayedMenus = document.querySelectorAll('.display_block');
            const parentULDisplayed = e.target.parentElement.closest('.display_block');
            const grandParentUlDisplayed = (parentULDisplayed) ? parentULDisplayed.parentElement.closest('.display_block') : null;


            displayedMenus.forEach(menu => {
                //check if the displayed UL is not a parent or a grandparent of the active focused tab
                if (menu !== parentULDisplayed && menu !== grandParentUlDisplayed) {
                    menu.classList.remove('display_block')
                }
            })

            //when hit ENTER to go to page, remove any displayed menu
            document.querySelectorAll('.display_block .dropdown-item').forEach(menItm => {
                menItm.addEventListener('keydown', function (event) {
                    if (event.key === 'Enter' || event.key === ' ') {
                        displayedMenus.forEach(mn => {
                            mn.classList.remove('display_block');
                        })
                    }
                });
            })
        }

        //if there are sub pages then return the component recursively
        if (menuItem.hasOwnProperty('sub_pages') && menuItem["sub_pages"].length > 0) {

            const subMenuItems = [];
            let colours = getColours();
            for (const [index, subMenuItem] of menuItem["sub_pages"].entries()) {
                let colour = getColourClass(colours, getColourIndex(index, colours));
                subMenuItems.push(<MenuItem key={index} data={subMenuItem} class={"dropdown-item " + colour} slug={menuItem.full_slug} />)
            }

            const topPagesSlug = addEndingSlashToSlug(menuItem.full_slug);

            const dealwith = (e) => {
                const parent = e.target.closest('.dropdown-with-submenus');
                const ulElement = parent.querySelector('ul');
                ulElement.classList.add("display_block");
                e.preventDefault();
            }
            return (
                <li className="dropdown dropdown-with-submenus" onFocus={(e) => removeDisplayBlockClass(e)}>
                    <Link className="dropdown-toggle" data-display="static" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" to={topPagesSlug} touch-action="auto">{menuItem.title}

                    </Link>
                    <button onClick={(e) => dealwith(e)} className="down-arrow" > &#9660;</button>
                    <ul className="dropdown-menu" role="menu">
                        {subMenuItems}
                    </ul>
                </li>
            )
        } else {

            let menuSlug = addEndingSlashToSlug(menuItem.full_slug);
            let linkClassName;
            if (this.props.hasOwnProperty("class")) {
                linkClassName = this.props.class;
            }

            return (
                <li onFocus={(e) => removeDisplayBlockClass(e)}>
                    <Link className={linkClassName} data-display="static" role="button" aria-haspopup="true" aria-expanded="false" to={`${menuSlug}`} touch-action="auto">{menuItem.title}</Link>
                </li>
            )
        }


    }
}

export default MenuItem;